import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface TestAssistantState {
  hasUnsavedChanges: boolean;
}

const initialState: TestAssistantState = {
  hasUnsavedChanges: false,
};

const testAssistantSlice = createSlice({
  name: 'testAssistant',
  initialState,
  reducers: {
    setHasUnsavedChanges: (
      state,
      { payload: hasUnsavedChanges }: PayloadAction<boolean>,
    ) => {
      state.hasUnsavedChanges = hasUnsavedChanges;
    },
  },
});

export const { setHasUnsavedChanges } = testAssistantSlice.actions;

export default testAssistantSlice.reducer;
